export default {"src":"/_next/static/media/chev-down.6bf9c64f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};